// extracted by mini-css-extract-plugin
module.exports = {"swiper":"SwiperSection_swiper___utPX","phoneSwiper":"SwiperSection_phoneSwiper__KXEDw","onlineButtonClass":"SwiperSection_onlineButtonClass__PBY4b"};